export default "__VITE_ASSET__e82da022__"